import { generatePath } from "react-router-dom";
import { takeLatest, put, call } from "redux-saga/effects";
import BackendClient from "api/backend-client";
import { RecipeScalingApiMethods } from "api/api-methods";
import RoutePaths from "routes/route-paths";
import { RequestTemplate } from "store/knowledge-base-item/knowledge-base-item.types";
import { loadLicensesListSaga } from "store/licensing/licensing.saga";
import { waitForLogin } from "../auth/auth.saga";
import { importRecipeFailure, importRecipeSuccessful, loadRecipeListFailure, loadRecipeListSuccessful, parseRecipeFailure, parseRecipeSuccessful, RecipeListActionType, } from "./recipe-list.actions";
import { setCurrentRequestTemplate } from "store/knowledge-base-item/knowledge-base-item.actions";
import { apiErrorHandler } from "store/global/global.saga";
import { navigate } from "shared/navigation";
export function* loadRecipesSaga() {
    try {
        yield call(waitForLogin);
        const backendClient = BackendClient.getInstance();
        const data = yield call([backendClient, RecipeScalingApiMethods.GetRecipeList]) || [];
        yield put(loadRecipeListSuccessful(data));
    }
    catch (e) {
        yield call(apiErrorHandler, e, "recipes load failed");
        yield put(loadRecipeListFailure());
    }
}
export function* parseRecipeSaga({ payload }) {
    try {
        yield call(waitForLogin);
        const backendClient = BackendClient.getInstance();
        yield put(setCurrentRequestTemplate(RequestTemplate.RECIPE_PARSE_FOR_IMPORT));
        const formData = new FormData();
        formData.append("file", payload, payload.name);
        const parsedRecipe = yield call([backendClient, RecipeScalingApiMethods.ParseRecipe], formData);
        yield put(parseRecipeSuccessful(parsedRecipe));
    }
    catch (e) {
        yield call(apiErrorHandler, e, "recipe import failed");
        yield put(parseRecipeFailure());
    }
}
export function* importRecipeSaga({ payload }) {
    try {
        yield call(waitForLogin);
        const backendClient = BackendClient.getInstance();
        yield put(setCurrentRequestTemplate(RequestTemplate.RECIPE_IMPORT));
        const id = yield call([backendClient, RecipeScalingApiMethods.ImportRecipe], payload);
        navigate(generatePath(RoutePaths.EditRecipe, { id }), null, true);
        yield call(loadLicensesListSaga);
        yield put(importRecipeSuccessful());
    }
    catch (e) {
        yield call(apiErrorHandler, e, "recipe import failed");
        yield put(importRecipeFailure());
    }
}
export default function* psWorkspaceListSaga() {
    yield takeLatest(RecipeListActionType.LOAD_LIST, loadRecipesSaga);
    yield takeLatest(RecipeListActionType.IMPORT, importRecipeSaga);
    yield takeLatest(RecipeListActionType.PARSE, parseRecipeSaga);
}
